<template>
    <div class="opui-container opui-max-900">
        <div class="opui-flow-list opui-item-list opui-workflow-is-loading">
            <ul>
                <li class="opfl-trigger-item" v-for="item in items">
                    <div class="opui-item op-flow-type-trigger">
                        <div class="opui-left">
                            <a href="#" class="op-flow-icon">
                                Icn
                            </a>
                            <div class="opui-title">
                                <p>Lorem ipsum dolorem sit</p>
                                <h3><a href="#">Lorem ipsum</a></h3>
                            </div>
                        </div>
                    </div>

                    <div class="op-flow-connector">
                        <a href="#" class="opui-flow-connector-add"></a>
                    </div>
                </li>
            </ul>
        </div>
    </div>
</template>

<script>
import ItemTrigger from "../Workflows/ItemTrigger.vue";

export default {
    components: {ItemTrigger},
    props: {
        itemRows: 0,
    },
    computed: {
        items: function () {
            return Array(this.itemRows ? this.itemRows : 10)
        },
    },
}
</script>
